import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '@wix/da-shared-react/pkg/utils/formatting';
import Flex from '@wix/da-ds/pkg/Flex';
import ProductListItem, { Props } from '../ProductListItem';
import ExclusivePriceStat from '../../../StudioDeviationList/items/ExclusiveListItem/_partials/ExclusivePriceStat';
import ExclusiveOffersStat from '../../../StudioDeviationList/items/ExclusiveListItem/_partials/ExclusiveOffersStat';
import ExclusiveOwner from '../../../StudioDeviationList/items/ExclusiveListItem/_partials/ExclusiveOwner';
import StatItem from '../../../StudioDeviationList/_partials/StatItem';
import DeviationInfo from '../../../StudioDeviationList/_partials/DeviationInfo';

const ExclusiveListItem: FC<Props> = ({
  deviation,
  offset,
  ...props
}) => {
  const { t } = useTranslation();
  const viewsCount = deviation.stats?.views ?? 0;
  const statsAndControls = (
    <Flex gap={24}>
      <ExclusivePriceStat deviation={deviation} />
      <StatItem
        title={t('studio.products.exclusive.stats.views')}
        value={formatNumber(viewsCount)}
      />
      <ExclusiveOffersStat deviation={deviation} />
    </Flex>
  );

  return (
    <ProductListItem
      deviation={deviation}
      offset={offset}
      subLabel={
        <>
          <DeviationInfo deviation={deviation} />
          <ExclusiveOwner deviation={deviation} />
        </>
      }
      bottomSlot={statsAndControls}
      {...props}
    />
  );
};
ExclusiveListItem.displayName = 'ExclusiveListItem';

export default ExclusiveListItem;
